import React from 'react';
import { motion } from 'framer-motion';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">About Dr Vaibhav Moghariya Clinic - Surendranagar's Leading Dermatology Center</h2>
          <p className="section-subtitle">
            Gujarat's most trusted and biggest skin clinic in Surendranagar district. We are your partners in achieving healthy, beautiful skin with advanced dermatological treatments and personalized care.
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div
            className="about-image-container"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80" alt="Best dermatologists at Dr Vaibhav Moghariya Clinic Surendranagar Gujarat" />
          </motion.div>

          <motion.div
            className="about-text-container"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3>Our Philosophy</h3>
            <p>At Dr Vaibhav Moghariya Clinic, we are proud to be the biggest and most advanced skin clinic in Surendranagar district, Gujarat. Our approach combines cutting-edge dermatological technology with personalized care, making us the preferred choice for patients across Gujarat. We serve the entire Surendranagar district with state-of-the-art treatments and experienced dermatologists.</p>

            <h3>Our Mission</h3>
            <p>Our mission is to provide the highest standard of skincare in a welcoming and professional environment. We are committed to helping you achieve your desired results through education, advanced technology, and a dedicated team of experts. Your skin health is our top priority.</p>

            <div className="about-stats">
              <div className="stat">
                <h4>10+</h4>
                <p>Years of Combined Experience</p>
              </div>
              <div className="stat">
                <h4>5,000+</h4>
                <p>Successful Treatments</p>
              </div>
              <div className="stat">
                <h4>100%</h4>
                <p>Client Satisfaction Rate</p>
              </div>
            </div>

          </motion.div>
        </div>

        {/* Meet Our Team Section */}
        <motion.div
          className="team-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="team-title">Meet Our Team</h3>
          <p className="team-subtitle">
            Our experienced team of professionals is dedicated to providing you with the highest quality care and exceptional results.
          </p>

          <div className="team-grid">
            {/* Dr. Vaibhav Moghariya */}
            <motion.div
              className="team-member lead-practitioner"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="member-image">
                <img
                  src="https://images.unsplash.com/photo-1582750433449-648ed127bb54?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                  alt="Dr. Vaibhav Moghariya"
                />
                {/* <div className="member-overlay">
                  <span className="member-role">Doctor</span>
                </div> */}
              </div>
              <div className="member-info">
                <h4>Dr. Vaibhav Moghariya</h4>
                {/* <p className="member-description">
                  Dr. Vaibhav Moghariya is our experienced dermatologist with extensive expertise in advanced skin treatments, 
                  laser therapies, and cosmetic procedures. He specializes in comprehensive skin care and rejuvenation techniques.
                </p>
                <div className="member-specialties">
                  <span className="specialty">Laser Treatments</span>
                  <span className="specialty">Anti-Aging</span>
                  <span className="specialty">Acne Treatment</span>
                  <span className="specialty">Chemical Peels</span>
                </div> */}
              </div>
            </motion.div>

            {/* Dr. Nirali Moghariya */}
            <motion.div
              className="team-member assistant-practitioner"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="member-image">
                <img
                  src="https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                  alt="Dr. Nirali Moghariya"
                />
                {/* <div className="member-overlay">
                  <span className="member-role">Doctor</span>
                </div> */}
              </div>
              <div className="member-info">
                <h4>Dr. Nirali Moghariya</h4>
                {/* <p className="member-description">
                  Dr. Nirali Moghariya is our skilled practitioner who specializes in skincare treatments, 
                  facial therapies, and patient care. She ensures every client receives personalized attention 
                  and comfortable treatment experience.
                </p> */}
                {/* <div className="member-specialties">
                  <span className="specialty">Facial Treatments</span>
                  <span className="specialty">Skin Analysis</span>
                  <span className="specialty">Patient Care</span>
                  <span className="specialty">Skincare Consultation</span>
                </div> */}
              </div>
            </motion.div>

            {/* Dr. N B Vanecha */}
            <motion.div
              className="team-member senior-practitioner"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="member-image">
                <img
                  src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                  alt="Dr. N B Vanecha"
                />
                {/* <div className="member-overlay">
                  <span className="member-role">Senior Doctor</span>
                </div> */}
              </div>
              <div className="member-info">
                <h4>Dr. N B Vanecha</h4>
                {/* <p className="member-description">
                  Dr. N B Vanecha is our senior practitioner with extensive experience in dermatological treatments 
                  and skin care solutions. He brings years of expertise in comprehensive skin health management.
                </p>
                <div className="member-specialties">
                  <span className="specialty">Dermatology</span>
                  <span className="specialty">Skin Health</span>
                  <span className="specialty">Medical Treatments</span>
                  <span className="specialty">Consultation</span>
                </div> */}
              </div>
            </motion.div>
          </div>

          <div className="team-cta">
            <p>Ready to start your skin transformation journey?</p>
            <button className="btn-primary">Book Consultation</button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
